import { render, staticRenderFns } from "./transition-fade.vue?vue&type=template&id=1e5d18ae"
import script from "./transition-fade.vue?vue&type=script&lang=js"
export * from "./transition-fade.vue?vue&type=script&lang=js"
import style0 from "./transition-fade.vue?vue&type=style&index=0&id=1e5d18ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports